import { render, staticRenderFns } from "./device018-a-newtrend.vue?vue&type=template&id=5b5a89f6&"
import script from "./device018-a-newtrend.vue?vue&type=script&lang=js&"
export * from "./device018-a-newtrend.vue?vue&type=script&lang=js&"
import style0 from "./device018-a-newtrend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports